import * as React from "react";
const SvgClipboard = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 12,
	height: 16,
	viewBox: "0 0 12 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10.6667 2.00033H7.88C7.6 1.22699 6.86667 0.666992 6 0.666992C5.13333 0.666992 4.4 1.22699 4.12 2.00033H1.33333C0.6 2.00033 0 2.60033 0 3.33366V14.0003C0 14.7337 0.6 15.3337 1.33333 15.3337H10.6667C11.4 15.3337 12 14.7337 12 14.0003V3.33366C12 2.60033 11.4 2.00033 10.6667 2.00033ZM6 2.00033C6.36667 2.00033 6.66667 2.30033 6.66667 2.66699C6.66667 3.03366 6.36667 3.33366 6 3.33366C5.63333 3.33366 5.33333 3.03366 5.33333 2.66699C5.33333 2.30033 5.63333 2.00033 6 2.00033ZM10 14.0003H2C1.63333 14.0003 1.33333 13.7003 1.33333 13.3337V4.00033C1.33333 3.63366 1.63333 3.33366 2 3.33366H2.66667V4.00033C2.66667 4.73366 3.26667 5.33366 4 5.33366H8C8.73333 5.33366 9.33333 4.73366 9.33333 4.00033V3.33366H10C10.3667 3.33366 10.6667 3.63366 10.6667 4.00033V13.3337C10.6667 13.7003 10.3667 14.0003 10 14.0003Z",
	fill: "black"
}));
export default SvgClipboard;
